<template>
  <div class="authorLists clearfix" :class="{ hei: type == 1 }">
    <div
      class="authorBox"
      v-for="(item, i) in list"
      :key="i"
      @click.stop.prevent="gotoacademyDetail(item.userId)"
    >
      <div class="bannerImg">
        <img class="imgs" :src="item.thumb | imageUrl('', 396, 222)" alt="" />
        <span class="ad" v-if="type == 1 && item.type == 2">{{
          $t("video.广告")
        }}</span>
      </div>
      <div class="titleBox">
        <div class="avatrBox">
          <img
            class="avatrImg"
            :src="
              item.avatar
                | imageUrl('/static/profile_img_default.png', 136, 136)
            "
            alt=""
          />
        </div>
        <p class="title">{{ item.nickname }}</p>
        <p class="area">{{ item.country }} {{ item.area }}</p>
        <p class="content">{{ item.field }}</p>
        <p class="numbers">
          <span>{{ $t("global.粉丝") }}</span
          ><i class="mar">{{ item.fansCount }}</i
          ><span class="gin">{{ $t("global.作品") }}</span
          ><i>{{ item.videoCount }}</i>
        </p>
        <div class="button" @click.stop.prevent="Follow(item)">
          <span class="text1" v-if="!item.isFollow">{{
            $t("video.+ 关注")
          }}</span>
          <span class="text2" v-else @mouseenter="isHover=true,hoverIndex=i" @mouseleave="isHover=false,hoverIndex=null">{{
            hoverIndex==i&&isHover?$t("global.取消关注"):$t("global.已关注")
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: "authorLists",
  data() {
    return {
      isHover: false,
      hoverIndex: null
    };
  },
  methods: {
    gotoacademyDetail(id) {
      let routeData = this.$router.resolve({
        path: "/peopleCenter/" + id + "/home",
      });
      window.open(routeData.href, "_blank");
    },
    Follow(item) {
      let that = this;
      if (!localStorage.getItem("auth_token")) {
        this.$router.push(
          "/login?redirecturl=" +
            window.location.pathname +
            window.location.search
        );
        return;
      }
      this.$http
        .post(
          `/api/u/relation/${!item.isFollow ? "follow" : "unfollow"}/${
            item.userId
          }`
        )
        .then(function (response) {
          if (response) {
            if (response.code === "OK") {
              item.isFollow = !item.isFollow;
              that.$message(response.message);
            }
          }
        });
    },
  },
  props: {
    list: Array,
    type: Number,
  },
  created() {},
  computed: {
    language() {
      return this.$language();
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.authorLists {
  width: 1110px;

  .authorBox {
    width: 198px;
    height: 318px;
    border: 1px solid #E0E0E0;
    float: left;
    margin-right: 30px;
    margin-bottom: 30px;
    cursor: pointer;
    box-sizing: border-box;

    &:nth-child(5n) {
      margin-right: 0;
    }

    .bannerImg {
      width: 196px;
      height: 111px;
      position: relative;
      .imgs {
        width: 100%;
        height: 100%;
      }

      .ad {
        position: absolute;
        left: 0;
        bottom: 0;
        padding: 0 4px;
        height: 16px;
        text-align: center;
        background: rgba(51, 51, 51, 0.4);
        border-radius: 0px 6px 0px 0px;
        line-height: 16px;
        font-size: 10px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.8);
      }
    }

    .titleBox {
      padding: 44px 15px 0;
      position: relative;

      .avatrBox {
        position: absolute;
        width: 68px;
        height: 68px;
        border: 2px solid #fff;
        background: #fff;
        left: 50%;
        top: -34px;
        transform: translateX(-50%);
        border-radius: 50%;

        .avatrImg {
          width: 68px;
          height: 68px;
          border-radius: 50%;
        }
      }

      .title {
        height: 23px;
        font-size: 15px;
        font-weight: 600;
        color: #0A0A0A;
        line-height: 23px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .area {
        height: 18px;
        font-size: 12px;
        font-weight: 400;
        color: #999999;
        line-height: 18px;
        margin: 8px 0;
        text-align: center;
      }

      .content {
        height: 18px;
        font-size: 12px;
        font-weight: 400;
        color: #999999;
        line-height: 18px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .numbers {
        height: 18px;
        font-size: 12px;
        font-weight: 400;
        color: #999999;
        line-height: 18px;
        margin: 12px 0;
        text-align: center;

        .mar {
          margin: 0 20px 0 5px;
        }

        .gin {
          margin-right: 5px;
        }
      }

      .button {
        text-align: center;

        .text1 {
          display: inline-block;
          padding: 0 12px;
          height: 24px;
          border: 1px solid #2026CC;
          line-height: 24px;
          font-size: 12px;
          font-weight: 600;
          color: #2026CC;
          margin: 0 auto;
          text-align: center;
        }

        .text2 {
          display: inline-block;
          padding: 0 12px;
          height: 24px;
          border: 1px solid #B8B8B8;
          line-height: 24px;
          font-size: 12px;
          font-weight: 600;
          color: #B8B8B8;
          margin: 0 auto;
          text-align: center;
        }
      }
    }
  }
}

.hei {
  height: 696px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/authorLists.vue